import React from 'react';
import SalesList from './SalesList';
import './Sales.css';

export default function Sales({invoices, selectedInvoice, setSelectedInvoice}) {
  return <div className="sales-container"><SalesList invoices={invoices} selectedInvoice={selectedInvoice} setSelectedInvoice={setSelectedInvoice}></SalesList></div>;
}